import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
const listeners = new Set();

export function refreshBranding() {
  return api.get("/branding").then((r) => {
    cached = r.data;
    listeners.forEach((cb) => cb(cached));
    return cached;
  }).catch(() => null);
}

export function useBranding() {
  const [b, setB] = useState(cached);
  useEffect(() => {
    if (!cached) refreshBranding();
    const cb = (val) => setB(val);
    listeners.add(cb);
    return () => listeners.delete(cb);
  }, []);
  return b || { name: "MX Academy", logo_data: null };
}
